import { render, staticRenderFns } from "./IconPlusCircle.vue?vue&type=template&id=272f813c"
import script from "./IconPlusCircle.vue?vue&type=script&lang=js"
export * from "./IconPlusCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports